"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var index_css_1 = __importDefault(require("./index.css"));
var login_form_1 = require("../../components/login-form");
var texts_1 = require("../../ui/texts");
function Login() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var loginStateValue = (0, recoil_1.useRecoilValue)(login_1.loginState);
    (0, react_1.useEffect)(function () {
        if (loginStateValue) {
            navigate("/");
        }
    }, [loginStateValue]);
    return (react_1.default.createElement("div", { className: index_css_1.default["login-container"] },
        react_1.default.createElement(texts_1.CustomTitle, null, "Ingresar"),
        react_1.default.createElement(login_form_1.LoginForm, null)));
}
exports.Login = Login;
